import bluemarvel from "@/assets/logos/bluemarvel.png";
import xq from "@/assets/logos/xq.png";
import vantedge from "@/assets/logos/vantedge.webp";
import powerdev from "@/assets/logos/powerdev.png";
import fieldsafe from "@/assets/logos/fieldsafe.svg";
import zayzoon from "@/assets/logos/zayzoon.svg";
import headversity from "@/assets/logos/headversity.png";
import visur from "@/assets/logos/visur.png";
import purelifecarbon from "@/assets/logos/purelifecarbon.png";

export const CLIENT_LOGOS: Record<string, string> = {
  bluemarvel,
  "xq-message": xq,
  "vantedge-logistics": vantedge,
  "power-dev": powerdev,
  "field-safe-solutions": fieldsafe,
};

export const INVESTMENT_LOGOS: Record<string, string> = {
  Zayzoon: zayzoon,
  Headversity: headversity,
  "XQ Message": xq,
  Visur: visur,
  FieldSafe: fieldsafe,
  "Pure Life Carbon": purelifecarbon,
};
